interface ErrorStateProps {
  title?: string;
  error: unknown;
}

export function ErrorState({ title = 'Something went wrong', error }: ErrorStateProps) {
  const message = error instanceof Error ? error.message : 'Unknown error';

  return (
    <div className="alert alert-danger" role="alert">
      <div className="fw-semibold">{title}</div>
      <div>{message}</div>
    </div>
  );
}
